/**
 * 渠道包列表页面
 */
import React from 'react'
import PureList from 'pureComponents/PureList'
import { OPERATION_LIST, OPERATION_STATUS } from './constants'
import useOperationList from './hooks/useOperationList'

const OperationList = (props = {}) => {
    const appInfo = props
    const { name, versionName, versionCode, openAppId } = appInfo
    const { state, setState, colRender, HeaderRightAddOn, bodyHeight } = useOperationList(appInfo)
    return (
        <div className="splitview-secs main main-full">
            <div className="titlebar splitview-titlebar channel-package-titlebar">
                <h2 className="title">{name}</h2>
                <div className="desc">
                    <div className="desc-item">应用 ID：{openAppId}</div>
                    <div className="desc-item">版本：{versionName}</div>
                    <div className="desc-item">Version Code：{versionCode}</div>
                </div>
            </div>
            <div className="card card-full">
                <PureList
                    {...state}
                    {...setState}
                    setState={setState}
                    columnsConfig={OPERATION_LIST}
                    colRender={colRender}
                    filterSelectData={OPERATION_STATUS}
                    HeaderRightAddOn={HeaderRightAddOn}
                    title={'投放账户列表'}
                    searchPlaceholder="投放账户ID"
                    showFilter={false}
                    fixedHeight={bodyHeight}
                />
            </div>
        </div>
    )
}

export default OperationList
